import { TimecardTemplateDto, TimecardTemplateSaveDto } from 'types/timecards';
import { portalAPI } from './portalAPI';

const APITimecardTemplatesSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['TimecardTemplates'] }).injectEndpoints({
    endpoints: (builder) => ({
        getTimecardTemplates: builder.query<TimecardTemplateDto[], void>({
            query: () => '/v1/timecard-templates',
            providesTags: ['TimecardTemplates'],
        }),
        getMatterTimecardTemplates: builder.query<
            TimecardTemplateDto[],
            { matterId: number; includeOtherMatterTypes: boolean }
        >({
            query: ({ matterId, includeOtherMatterTypes }) => ({
                url: `/v1/timecard-templates/for-matter/${matterId}`,
                params: { includeOtherMatterTypes },
            }),
            providesTags: ['TimecardTemplates'],
        }),
        addTimecardTemplate: builder.mutation<TimecardTemplateDto, TimecardTemplateSaveDto>({
            query: (body) => ({ url: '/v1/timecard-templates', method: 'POST', body }),
            invalidatesTags: ['TimecardTemplates'],
        }),
        updateTimecardTemplate: builder.mutation<TimecardTemplateDto, { id: number } & TimecardTemplateSaveDto>({
            query: ({ id, ...body }) => ({ url: `/v1/timecard-templates/${id}`, method: 'PUT', body }),
            invalidatesTags: ['TimecardTemplates'],
        }),
        deleteTimecardTemplate: builder.mutation<void, number>({
            query: (id) => ({ url: `/v1/timecard-templates/${id}`, method: 'DELETE' }),
            invalidatesTags: ['TimecardTemplates'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetTimecardTemplatesQuery,
    useGetMatterTimecardTemplatesQuery,
    useAddTimecardTemplateMutation,
    useUpdateTimecardTemplateMutation,
    useDeleteTimecardTemplateMutation,
} = APITimecardTemplatesSlice;
